import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  CARD_TYPE_LIST_START: "CARD_TYPE_LIST_START",
  CARD_TYPE_LIST_FAIL: "CARD_TYPE_LIST_FAIL",
  CARD_TYPE_LIST_SUCCESS: "CARD_TYPE_LIST_SUCCESS",
};

// ============================================ Actions ========================================================

export const cardTypeListStart = (data) => ({
  type: actionType.CARD_TYPE_LIST_START,
  payload: data,
});

export const cardTypeListFail = (data) => ({
  type: actionType.CARD_TYPE_LIST_FAIL,
  payload: data,
});

export const cardTypeListSuccess = (data) => ({
  type: actionType.CARD_TYPE_LIST_SUCCESS,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function cardTypeListReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.CARD_TYPE_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.CARD_TYPE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.CARD_TYPE_LIST_FAIL:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* cardTypeListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      yield put(cardTypeListSuccess(response.data.data.allCardtypes.Cardtypes));
    } else {
      messagePopup("", "Card type List failed", "error");
      yield put(cardTypeListFail("Card type List failed"));
    }
  } catch (error) {
    messagePopup("", "Card type List failed", "error");
    yield put(cardTypeListFail("Card type List failed"));
  }
}

export function* watchCardTypeListSaga() {
  yield takeEvery(actionType.CARD_TYPE_LIST_START, cardTypeListSaga);
}
